<template>
    <div class="c-domain-info">
        <div class="c-domain-info__cell c-domain-info__cell--title">
            {{ trans('domain') }}
        </div>
        <div class="c-domain-info__cell c-domain-info__cell--domain">
            <strong>{{ data.domain }}</strong>
        </div>
        <div class="c-domain-info__cell c-domain-info__cell--availability" :class="{ 'c-domain-info__cell--available' : data.available, 'c-domain-info__cell--unavailable' : !data.available }">
            <span>{{ data.available ? trans('free') : trans('reserved') }}</span>
        </div>
        <div class="c-domain-info__cell c-domain-info__cell--price">
            {{ data.price }} GEL
        </div>
        <div class="c-domain-info__cell c-domain-info__cell--info">
            <a :href="`http://bill.serv.ge/cart.php?a=add&domain=register&direct=true&sld=${domain}&tld=${tld}`" target="blank" rel="noopener" v-if="data.available">{{ trans('register') }}</a>
            <a :href="`https://ns.ge/index.php?m=3&domain=${domain}&tld=${tld}`" target="blank" rel="noopener" v-else>{{ trans('information') }}</a>
        </div>
    </div>
</template>

<script>
import trans from '../mixins/trans';
export default {
    name: 'domain-info',
    props: ['data'],
    mixins: [trans],
    computed: {
        domain() {
            return this.data.domain.split('.')[0];
        },
        tld() {
            console.log(this.data.domain);
            return this.data.domain
                .split('.')
                .slice(1, 10)
                .join('.');
        }
    }
};
</script>

<style lang="scss">
.text-danger {
    color: red;
}
.text-success {
    color: #31cc06 !important;
}
.text-white {
    color: #fff;
}
.c-domain-info {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    margin: 0;
    background-color: #f7f6f0;
    box-sizing: border-box;
    cursor: pointer;
    transition: box-shadow 0.3s;
    &:hover {
        z-index: 10;
        box-shadow: 0 2px 9px 1px rgba(0, 0, 0, 0.25);
        .c-domain-info__cell {
            &--title {
                background-color: #6893b6;
                color: #fff;
            }
            &--available {
                background-color: #31cc06;
                color: #fff;
            }
            &--unavailable {
                background-color: red;
                color: #fff;
            }
        }
    }
    &__cell {
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid white;
        height: 40px;
        font-family: 'Verdana', sans-serif;
        &--title {
            width: 12%;
            transition: background-color 0.3s, color 0.3s;
        }
        &--domain {
            width: 38%;
            font-size: 14px;
        }
        &--availability {
            width: 20%;
            transition: background-color 0.3s, color 0.3s;
        }
        &--available {
            color: #31cc06;
        }
        &--unavailable {
            color: red;
        }
        &--price {
            width: 10%;
        }
        &--info {
            width: 20%;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/DomainInfo.vue